module.exports = __webpack_public_path__ + "static/media/s_4_1.677030be.png";